import React from "react";
import './header.css';

function Header() {
    return (
        <div className="contener">
            <h1>Jamming</h1>
        </div>
    );
};

export default Header;